import { Params, ParamsWithId, ParamsIds } from './types';

export function makeResourceKeys<Entity extends string>(entity: Entity) {
  const entityKeys = {
    $all: [entity] as const,
    $many: () => [...entityKeys.$all, 'many'] as const,
    many: (params: Params = {}) => [...entityKeys.$many(), params] as const,
    $entity: () => [...entityKeys.$all, 'entity'] as const,
    $entityId: (id: string) => [...entityKeys.$entity(), id] as const,
    $byIds: () => [...entityKeys.$all, 'byIds'] as const,
    byIds: (params: ParamsIds) => [...entityKeys.$byIds(), params] as const,
    entity: ({ id, ...params }: ParamsWithId) => [...entityKeys.$entity(), id, params] as const,
  } as const;

  return entityKeys;
}
